<template>
    <div
        id="pro-layout"
        :class="[leftMenuClosed ? 'closed' : 'opened', noMenu ? 'm-0 bg-transparent' : '']"
    >
        <div
            class="sm-top-menu d-block d-sm-none d-flex justify-content-between shadow-sm"
            v-if="showResponsiveBurger"
        >
            <div>
                <v-img
                    src="/images/Logo_Dahub_Official_2019.png"
                    width="130px"
                    height="40px"
                ></v-img>
            </div>
            <div class="mt-auto mb-auto mr-3">
                <v-menu bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            dark
                            icon
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon
                                large
                                color="#1398b5"
                            >menu
                            </v-icon
                            >
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item
                            link
                            @click="redirect('/espace-pro/' + token + '/solicitations')"
                        >
                            <v-list-item-icon>
                                <v-icon>assignment</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>Mes sollicitations</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                            link
                            @click="redirect('/espace-pro/' + token + '/review')"
                        >
                            <v-list-item-icon>
                                <v-icon>rate_review</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>Votre avis</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item link @click="redirect('/espace-pro/' + token + '/uska')"
                                     v-if="uskaFreemium && providersCount > 0 && hasProviders">
                            <v-list-item-icon>
                                <img src="/images/logo_USKA_empty_blue.png" class="uska-icon"/>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>Mon compte Uska</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
        </div>
        <pro-menu v-if="!noMenu"
                  :has-providers="hasProviders"
                  :has-uska="hasUska"
                  :providers-count="providersCount"
                  :uska-freemium="uskaFreemium">
        </pro-menu>

        <div
            class="pro-main-container"
            :class="[noMenu ? 'bg-transparent' : '']"
        >
            <pro-dashboard v-if="matchPath('solicitations')"
                           :has-providers="hasProviders"
                           :has-uska="hasUska"
                           :uska-freemium="uskaFreemium"
                           :providers-count="providersCount">
            </pro-dashboard>
            <pro-profil v-if="matchPath('profil')"></pro-profil>
            <pro-review v-if="matchPath('review')"></pro-review>
            <cmaj-form v-if="matchPath('formulaire')"></cmaj-form>
            <pro-adhesion v-if="matchPath('adhesion')"></pro-adhesion>
            <pro-uska-link v-if="matchPath('uska')"></pro-uska-link>
        </div>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import ProMenu from "./ProMenu"
import ProDashboard from "./ProDashboard"
import ProProfil from "./ProProfil"
import {mapState} from "vuex"
import ProReview from "./ProReview"
import CmajForm from "./CMAJ/CmajForm.vue"
import Confirm from "../tools/Confirm"
import ProAdhesion from "./ProAdhesion"
import ProUskaLink from "./ProUskaLink.vue"
import axios from "axios"

export default {
    name: "ProLayout",
    components: {ProAdhesion, Confirm, CmajForm, ProReview, ProProfil, ProDashboard, ProMenu, ProUskaLink},
    data() {
        return {
            token: null,
            noMenu: false,
            hasProviders: false,
            hasUska: false,
            providersCount: 0,
            uskaFreemium: false,
        }
    },
    methods: {
        matchPath(path) {
            return this.$route.params.pathMatch.includes(path)
        },
        redirect(link) {
            if (this.matchPath("formulaire") && this.isDirty) {
                this.$refs.confirm
                    .open("Attention", "Vous allez quitter la page sans avoir validé ou enregistré votre formulaire.<br>", {
                        color: "red",
                        confirmColor: "red",
                        cancelColor: "#0b697e",
                    })
                    .then((confirm) => {
                        if (confirm) {
                            this.$router.push(link)
                        }
                    })
            } else {
                this.$router.push(link)
            }
        },
        async getProvidersContact() {
            const apiKey = process.env.VUE_APP_API_KEY_PH_HUBO
            const url = process.env.VUE_APP_API_URL + "/presence-hub/contact-providers/" + this.token + "?api_key=" + apiKey

            await axios.get(url).then((res) => {
                if (res.data.success && res.data.data.length) {
                    this.hasProviders = true
                }
            })
        },
        async checkUska() {
            let res = await this.$http.get("professional/first-provider/" + this.token)

            this.providersCount = res.body.data.providersCount
            this.uskaFreemium = res.body.data.uskaFreemium

            if (this.providersCount > 0) {
                this.hasUska = res.body.data.hasUska
            }
        },
    },
    computed: {
        ...mapState("global", ["leftMenuClosed"]),
        ...mapState("web_form", ["isDirty"]),

        showResponsiveBurger() {
            return this.$route.query.origin !== "USKA"
        },
    },

    async created() {
        window.Intercom("shutdown")
        window.Intercom("hide")

        this.noMenu = this.$route.query.hidden && this.$route.query.hidden.includes("APP_MENU")

        this.token = this.$route.params.token

        await this.getProvidersContact()

        await this.checkUska()
    },
}
</script>
